import React from "react";
import { Box, Flex } from "@chakra-ui/react";

/**
 * StatusBadge — a dot-prefixed status label. The dot + text colour come from a
 * Chakra colorScheme (the same scheme strings used in `constants/statuses.js`,
 * e.g. green/red/blue/gray/orange/purple/yellow/cyan).
 * Template ref: `.status` + `.status::before`.
 *
 * Props:
 *   label       - the status text (already translated by the caller)
 *   colorScheme - Chakra colour-scale key (default "gray"). MUST be a scale
 *                 registered in the theme (green/mint/gray/blue/red/orange/
 *                 purple/yellow/cyan); the dot halo reads `--chakra-colors-
 *                 ${scheme}-100`, so an unregistered name yields no halo.
 *                 The status colour maps in `constants/statuses.js` only emit
 *                 these keys.
 */
const StatusBadge = ({ label, colorScheme = "gray", ...rest }) => {
  const scheme = colorScheme || "gray";
  return (
    <Flex
      as="span"
      display="inline-flex"
      align="center"
      gap="6px"
      fontSize="11px"
      fontWeight="900"
      color={`${scheme}.600`}
      whiteSpace="nowrap"
      {...rest}
    >
      <Box
        as="span"
        w="7px"
        h="7px"
        borderRadius="999px"
        bg={`${scheme}.500`}
        boxShadow={`0 0 0 4px var(--chakra-colors-${scheme}-100)`}
        flexShrink={0}
      />
      {label}
    </Flex>
  );
};

export default StatusBadge;
